import { createCustomEnum } from "./customEnum";

const ZeroCostProgramTypes = createCustomEnum({
	None: {
		name: "none",
		value: 0,
		displayName: "None",
	},
	CashDiscount: {
		name: "cashDiscount",
		value: 1,
		displayName: "Cash Discount",
	},
	DuoPricing: {
		name: "duoPricing",
		value: 2,
		displayName: "Duo Pricing",
	},
	Surcharge: {
		name: "surcharge",
		value: 3,
		displayName: "Surcharge",
	},
});

export default ZeroCostProgramTypes;
